export const formatValue = (value) => {
  return Number(value).toLocaleString('it-IT', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const filterAndSortByValue = (arr) => {
  return arr.filter((item) => item.proponent !== 'portfolio').sort((a, b) => a.value - b.value);
};

export const mapProponentData = (arr, labelOptions) => {
  return arr.map((item) => ({
    axis: labelOptions.find((opt) => opt.value === item.proponent)?.label || item.proponent,
    value: item.value < 0 ? 0 : item.value,
  }));
};

export const mergeAvgAndStdDev = (avgArr, stdDevArr) => {
  return avgArr.map((item) => {
    const stdDevValue = stdDevArr.find((s) => s.proponent === item.proponent)?.value || 0;
    return { proponent: item.proponent, avgValue: item.value, stdDevValue };
  });
};

export const calculateAverageScore = (projects) => {
  const scores = projects
    .filter((proj) => proj.status === 'SUBMITTED')
    .flatMap((proj) =>
      proj.esgratings.filter((rat) => rat.type === 'total').map((rat) => rat.score)
    );

  if (scores.length === 0) return 0;

  const sum = scores.reduce((a, b) => a + b, 0);
  return sum / scores.length;
};

export const mapScoreToRating = (avg) => {
  if (avg < 20) return 'C';
  if (avg < 30) return 'B';
  if (avg < 40) return 'BB';
  if (avg < 50) return 'BBB';
  if (avg < 60) return 'A';
  if (avg < 70) return 'A+';
  if (avg < 80) return 'AA';
  if (avg < 90) return 'AA+';
  return 'AAA';
};
